import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\BatchOperation\GetBatchOperationSchemaController::__invoke
* @see app/Http/Controllers/BatchOperation/GetBatchOperationSchemaController.php
* @route '/api/batch-operations/schema'
*/
const GetBatchOperationSchemaController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetBatchOperationSchemaController.url(options),
    method: 'get',
})

GetBatchOperationSchemaController.definition = {
    methods: ["get","head"],
    url: '/api/batch-operations/schema',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\BatchOperation\GetBatchOperationSchemaController::__invoke
* @see app/Http/Controllers/BatchOperation/GetBatchOperationSchemaController.php
* @route '/api/batch-operations/schema'
*/
GetBatchOperationSchemaController.url = (options?: RouteQueryOptions) => {
    return GetBatchOperationSchemaController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BatchOperation\GetBatchOperationSchemaController::__invoke
* @see app/Http/Controllers/BatchOperation/GetBatchOperationSchemaController.php
* @route '/api/batch-operations/schema'
*/
GetBatchOperationSchemaController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetBatchOperationSchemaController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\BatchOperation\GetBatchOperationSchemaController::__invoke
* @see app/Http/Controllers/BatchOperation/GetBatchOperationSchemaController.php
* @route '/api/batch-operations/schema'
*/
GetBatchOperationSchemaController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetBatchOperationSchemaController.url(options),
    method: 'head',
})

export default GetBatchOperationSchemaController